module.exports = __webpack_public_path__ + "img/76325.fd9c9ee0.svg";